/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientExternalCard/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Avatar from './Avatar/index'
import Dob from './Dob/index'
import Email from './Email/index'
import FirstName from './FirstName/index'
import Gender from './Gender/index'
import LastName from './LastName/index'
import Phone from './Phone/index'
import React from 'react'
import Tag from './Tag/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import Zip from './Zip/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientExternalCard({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/SyncPatients/Content/PatientExternalCard"
  
}) {
let matchSelectedValueData = fromData.useDataValue({ viewPath,
context: 'match',
path: 'selected',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="PatientExternalCard.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-A06qQ': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-2-A06qQ': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-3-A06qQ': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-4-A06qQ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-A06qQ': matchSelectedValueData ? dtColorsNeutral100 : dtColorsWhite}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="PatientExternalCard.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
/>
<div
  data-testid="PatientExternalCard.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="PatientExternalCard.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="PatientExternalCard.Horizontal:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal3}`}
>
<FirstName
  viewPath={`${viewPath}/FirstName`}
/>
<LastName
  viewPath={`${viewPath}/LastName`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 text="•"
 marginLeft={dtSpaceXxs}
/>
<Gender
  viewPath={`${viewPath}/Gender`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 text="•"
 marginLeft={dtSpaceXxs}
/>
<Dob
  viewPath={`${viewPath}/Dob`}
/>
</div>
</div>
<div
  data-testid="PatientExternalCard.Horizontal:4"
  data-view-path={viewPath}
 style={{'--mt-6-A06qQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal4}`}
>
<Email
  viewPath={`${viewPath}/Email`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 text="•"
 marginLeft={dtSpaceXxs}
/>
<Phone
  viewPath={`${viewPath}/Phone`}
/>
</div>
<div
  data-testid="PatientExternalCard.Horizontal:5"
  data-view-path={viewPath}
 style={{'--mt-6-A06qQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal5}`}
>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
<Tag
  viewPath={`${viewPath}/Tag`}
/>
</div>
</div>
</div>
</div>
{children}
</React.Fragment>)
}